import React, { Component } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';

import { translate } from 'react-i18next';
import { ReduxAsyncConnect, asyncConnect, reducer as reduxAsyncConnect } from 'redux-connect';

import { isLoaded as areProductsLoaded, load as loadFiches } from 'redux/modules/products';
import * as ProductActions from 'redux/modules/products';

import { ProductForm, ModeOpe } from 'components';

import { isLoaded as areGroupsLoaded, load as loadGroups } from 'redux/modules/groups';
import { isLoaded as areUsersLoaded, load as loadUsers } from 'redux/modules/users';

require('./geosuggest.css');

import ReactModal from 'react-modal';

import { Button, Col } from 'react-bootstrap';

var modalStyles =
{
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.75)',
    zIndex: 1000000
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '700px',
    height: '400px'

  }
}

@translate(['common'])
@asyncConnect([{
  promise: ({ store: { dispatch, getState }, params }) => {
    const promises = [];
    promises.push(dispatch(ProductActions.loadPhones(params)));
    promises.push(dispatch(loadGroups(params)));
    promises.push(dispatch(loadUsers(params)));
    return Promise.all(promises);
  }
}])
@connect(
  state => ({
    groups: state.groups.data,
    phones: state.products.phones,
    users: state.users.data
  })
)
export default class AddProduct extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  handleOpenModal() {
    this.setState({ showModal: true });
  }

  handleCloseModal() {
    var self = this;
    this.setState({ showModal: false });

  }

  render() {

    const {
      t, groups, phones, users
    } = this.props;

    const styles = require('./AddProduct.scss');

    var product = { identification_NUM_MOD: 1 }

    return (
      <div className={styles.loginPage + ' container'}>
        <Helmet title={t("main.create_sheet")} />
        <h1>
          {t("main.create_sheet")}
          <Button bsStyle="primary" onClick={this.handleOpenModal}>
            {t("main.help")}
          </Button>
        </h1>

        <ProductForm action='create'
          urlParams={this.props.params}
          formKey="createProduitForm1"
          phones={phones}
          pristineValues={{ groups: groups, product }}
          initialValues={{ groups: [], product }}
          users={users}
        />

        <Col xs={12} md={12}>
          <ReactModal
            isOpen={this.state.showModal}
            contentLabel="" style={modalStyles}
          >
            <div>
              <div style={{position:'sticky', top: 0, textAlign:'right', background:'white', padding:'5px 0', zIndex: 1}}>
                <i onClick={this.handleCloseModal} className="fa fa-times-circle fa-2x" style={{color: '#888', cursor:'pointer'}}/>
              </div>
              <p><ModeOpe /></p>
            </div>
          </ReactModal>
        </Col>
      </div>
    );
  }
}
